import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { NextSeo } from "next-seo";
import Link from "next/link";
import { useRouter } from "next/router";
import { Col, Row } from "react-styled-flexboxgrid";
import styled from "styled-components";
import Public from "../../Layouts/Public";
import Button from "../../components/Button/Button";
import Heading from "../../components/Heading";
import PageSection from "../../components/PageSection";
import AmeegoExplanationText from "../../components/Public/Ameego/AmeegoExplanationText";
import Spacer from "../../components/Spacer";
import { siteTitle } from "../../data/PublicSiteData";
import { trackPageView } from "../../includes/analytics";
import { Color } from "../../theme/Color";

const StyledLink = styled.a`
  text-decoration: none;
`;

const AmeegosPage = () => {
  const router = useRouter();

  trackPageView("/ameegos");

  return (
    <>
      <NextSeo
        title={`Ameegos | ${siteTitle}`}
        description="Valmeego is a new way for destinations and visitors to interact online.
Get inspiration, local knowledge, advice & deals directly from any destination."
      />
      <PageSection fullHeight={true} backgroundColor={Color.White}>
        <Row middle="xs">
          <Col xs={12}>
            <Heading
              centered
              fontColor={Color.Black}
              size={4}
              margin="6rem 0 6rem 0"
            >
              What type of Ameego are you?
            </Heading>
          </Col>
        </Row>

        <Row center="xs">
          <Col
            xs={12}
            sm={6}
            lg={4}
            style={{ color: "black", margin: "0 0 3rem 0" }}
          >
            <Spacer left={1} right={1}>
              <Heading
                size={4}
                centered
                fontColor={Color.Black}
                margin="0 0 2rem 0"
              >
                <Link href="/ameegos/local" passHref>
                  <StyledLink>Local Ameego</StyledLink>
                </Link>
              </Heading>
              <Heading margin="0 0 2rem 0" fontColor={Color.Black}>
                A local Ameego has extensive knowledge of the destination, area,
                or tourist region you are planning to visit.
              </Heading>

              <p>
                They may also have personal in-depth knowledge of a particular
                activity, interest, or hobby in that destination e.g., hiking,
                food experiences etc.
              </p>
              <p>
                A local Ameego is a helpful local with particular knowledge
                which they are willing to share so that members may experience
                the best of their area.
              </p>
              <AmeegoExplanationText />
              <Button
                label={"Find Out More"}
                onClick={() => {
                  router.push("/ameegos/local");
                }}
                icon={<FontAwesomeIcon icon={faChevronRight} />}
              />
            </Spacer>
          </Col>
          <Col
            xs={12}
            sm={6}
            lg={4}
            style={{ color: "black", margin: "0 0 3rem 0" }}
          >
            <Spacer left={1} right={1}>
              <Heading
                size={4}
                centered
                fontColor={Color.Black}
                margin="0 0 2rem 0"
              >
                <Link href="/ameegos/trip" passHref>
                  <StyledLink>National Ameego</StyledLink>
                </Link>
              </Heading>
              <Heading margin="0 0 2rem 0" fontColor={Color.Black}>
                A trip / national Ameego is an individual who can help you with
                your queries across the whole of your trip journey.
              </Heading>
              <p>
                They will know a wider geographic area than a local Ameego and
                they may already work in the tourist industry providing tours or
                other services. They will have a vast knowledge of destinations,
                offering insights on everything there is to see, do, and book,
                including attractions, accommodations, dining options,
                activities, and local culture. They work closely with trip
                planners to provide recommendations and guidance throughout the
                entire trip journey.
              </p>
              <p>
                A trip / national Ameego will be an invaluable source of
                knowledge and inspiration to you on your trip.
              </p>
              <AmeegoExplanationText />
              <Button
                label={"Find Out More"}
                onClick={() => {
                  router.push("/ameegos/trip");
                }}
                icon={<FontAwesomeIcon icon={faChevronRight} />}
              />
            </Spacer>
          </Col>
          <Col
            xs={12}
            sm={6}
            lg={4}
            style={{ color: "black", margin: "0 0 3rem 0" }}
          >
            <Heading
              size={4}
              centered
              fontColor={Color.Black}
              margin="0 0 2rem 0"
            >
              <Link href="/ameegos/specialist" passHref>
                <StyledLink>Specialist Ameego</StyledLink>
              </Link>
            </Heading>
            <Heading margin="0 0 2rem 0" fontColor={Color.Black}>
              A specialist Ameego is an expert who provides you with specific
              recommendations and guidance on specialised aspects of travel to
              and in particular destinations.
            </Heading>

            <p>
              Based on the requirements and preferences you provide they can
              provide you with personalised options using their expert
              knowledge.
            </p>
            <AmeegoExplanationText />
            <p>Examples of Specialist topics include:</p>

            <ul>
              <li>Car hire</li>
              <li>Airlines and Flights</li>
              <li>Ferries and routes</li>
              <li>Motorhome hire</li>
              <li>Specialist activities and tours</li>
            </ul>
            <Button
              label={"Find Out More"}
              onClick={() => {
                router.push("/ameegos/specialist");
              }}
              icon={<FontAwesomeIcon icon={faChevronRight} />}
            />
          </Col>
        </Row>
      </PageSection>
    </>
  );
};

AmeegosPage.Layout = Public;
AmeegosPage.Title = "Valmeego - Locally and beyond";

export default AmeegosPage;
